(() => {
  'use strict';

  const contentSelector = '[data-enchliving-dynamic-metafield-content]';
  const productTemplateSelector = '[data-enchliving-product-metafield-template]';

  function updateSpecifications(variantId) {
    document.querySelectorAll(contentSelector).forEach((content) => {
      const accordionContent = content.closest('.accordion__content') || document;
      const variantTemplate = variantId
        ? accordionContent.querySelector(`[data-enchliving-variant-metafield-template="${variantId}"]`)
        : null;
      const productTemplate = accordionContent.querySelector(productTemplateSelector);
      const template = variantTemplate || productTemplate;

      if (!template) return;

      content.innerHTML = template.innerHTML;
    });
  }

  document.addEventListener('variant:change', (event) => {
    const variantId = event.detail?.variant?.id;
    updateSpecifications(variantId);
  });
})();
